import { Injectable } from '@angular/core';
import {
  GetCaptchaInfo,
  IGetCaptchaInfo
} from 'client/models/form/captcha.model';
import { Observable, map } from 'rxjs';

import { prepareAttendanceFormApiUrl } from '../app.const';
import { AppHttpClient } from 'common/service/app-http-client.service';
import {
  AttendanceContactDetail,
  AttendanceInfo,
  IAttendanceContactResponseHttp,
  IAttendanceResponseHttp,
  IAttendanceSaveRequestHttp
} from 'attendance/model/attendance.model';

const HttpServiceMethods = {
  getAttendanceFormInfoUrl: () =>
    prepareAttendanceFormApiUrl(`GetAttendanceFormInfo`),
  GetAttendanceContactGridInfo: () =>
    prepareAttendanceFormApiUrl(`GetAttendanceContactGridInfo`),
  saveAttendanceFormAnswerUrl: () =>
    prepareAttendanceFormApiUrl('SaveAttendanceFormAnswer'),
  getCaptchaInfoUrl: () =>
    prepareAttendanceFormApiUrl('GetAttendanceCaptchaInfo')
};
@Injectable()
export class AttendanceFormService {
  constructor(private httpService: AppHttpClient) {}

  public getAttendanceFormInfo(): Observable<AttendanceInfo> {
    return this.httpService
      .get<IAttendanceResponseHttp>(
        HttpServiceMethods.getAttendanceFormInfoUrl()
      )
      .pipe(map((item) => AttendanceInfo.fromJson(item)));
  }

  public getAttendanceContactGridInfo(): Observable<AttendanceContactDetail> {
    return this.httpService
      .get<IAttendanceContactResponseHttp>(
        HttpServiceMethods.GetAttendanceContactGridInfo()
      )
      .pipe(map((item) => AttendanceContactDetail.fromJson(item)));
  }

  public saveAttendanceFormAnswer(
    body: IAttendanceSaveRequestHttp
  ): Observable<{ message: string }> {
    return this.httpService.post<{ message: string }>(
      HttpServiceMethods.saveAttendanceFormAnswerUrl(),
      body
    );
  }

  public getCaptchaInfo(): Observable<GetCaptchaInfo> {
    return this.httpService
      .get<IGetCaptchaInfo>(HttpServiceMethods.getCaptchaInfoUrl())
      .pipe(map((item) => GetCaptchaInfo.fromJson(item)));
  }
}
